/* eslint-disable no-warning-comments */
/* globals fbq */

import LandingPage from "./Components/LandingPage/LandingPage.js";
// import GoogleDetails from "./Components/LandingPage/SignUp/GoogleDetails.js";

import { withRouter } from "react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import Header from "./Components/Header/Header.js";
// import AccountInfo from "./Components/AccountInfo/AccountInfo.js";
import { useContext, useEffect, lazy, Suspense, Fragment } from "react";
import PrivateRoutes from "./private/PrivateRoutes.js";
import RouteLinks from "./private/RouteLinks.js";
// import Loading from "./Components/Loading/Loading.js";
// import EditImage from "./Components/Edit/EditImage.js";
import LoginRouteLink from "./private/LoginRouteLink.js";
import AdminRoutes from "./private/AdminRoutes.js";
// import Edit from "./Components/Edit/Edit.js";
// import HomePage from "./pages/HomePage/HomePage.js";
// import Skillmodel from "./Components/SelectSkills/Skillmodel.jsx";
import ReactGA from "react-ga4";
import React from "react";
import FallbackUI from "./Components/Loading/FallbackUI.js";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { WebSocketContext } from "./WebSocket.js";
// import PeerInterest from "./Components/PeerInterests/PeerInterest.js";
import SocketNotification from "./Components/SocketNotification/SocketNotification.js";
import CompetitionPanel from "./Components/ContestPanel/Competition.js";
import MarketingAdminRoutes from "./private/MarketingAdminRoutes.js";
import JudgingPanel from "./Components/ContestPanel/JudgingPanel.js";
// import CompetitionMobile from "./Components/competition/CompetitionMobile.jsx";
import AllComp from "./Components/competition/AllComp.jsx";
// import Rewards from "./Components/competition/Rewards.jsx";
// import RewardsMobile from "./Components/competition/RewardsMobile.jsx";
// import Judges from "./Components/competition/Judges.jsx";
import ContestEdit from "./Components/Edit New Contest/ContestEdit.jsx";

// import Submission from "./Components/competition/Submission/Submission.jsx";
import SubmissionsList from "./Components/ContestPanel/SubmissionsList.js";
// import JudgingPanel from "./Components/ContestPanel/JudgingPanel.js";
// import CompetitionNew from "./Components/competition/CompetitionNew.jsx";
// import MyStatistics from "./Components/MyStatistics/my-statistics-mobile.jsx";
// import MyStatisticsDesktop from "./Components/MyStatistics/my-statistics-desktop.jsx";
import DeepLinkBanner from "./pages/DeepLinkBanner/DeepLinkBanner.js";
// import MyPeer from "./Components/AllFriendsPopUp.js/MyPeer.js";
import JudgeApplicantLists from "./Components/ContestPanel/JudgeApplicantLists.js";
import AdvertiserPanel from "./Components/ContestPanel/AdvertiserPanel.jsx";
import CreateJudgeApplication from "./Components/ContestPanel/CreateJudgeApplication.jsx";
import CreateAdvertiser from "./Components/ContestPanel/CreateAdvertiser.jsx";
import AppDownload from "./Components/DownloadAppPage/DownloadAppPage.js";
import ContestDetails from "./Components/WebApp/ContestDetails.js";
import ApplyAsJudge from "./Components/WebApp/ApplyAsJudge/ApplyAsJudge.jsx";
import GetHelp from "./Components/WebApp/GetHelp.js"
import LeaderBoard from "./Components/WebApp/LeaderBoard.js"
import Competition from "./Components/WebApp/Competition.js";
import PaymentStatus from "./Components/PaymentLinkStatus/PaymentLinkStatus.jsx";
import { ENV, path } from "./path.js";
import UserProfile from "./Components/WebApp/JudgeProfile/UserProfile.js";
import VideoUploadTester from "./pages/VideoUploadTester/videoUploadTester.js";
import axios from "axios";
import { UPDATE_ACCOUNT } from "./store/types/AuthTypes.js";
import ReferralLinkBanner from "./pages/DeepLinkBanner/ReferralLinkBanner.js";
import { captureAttributionFromUrl } from "./Utils/attribution.js";
import UrlRedirectPage from "./Components/WebApp/UrlRedirectPage.jsx";
import { getPlaystoreLinks } from "./Utils/attribution.js"
import ARDashboard from "./pages/AntRewardsDashboard/Dashboard.js";

const CertificateView = lazy(() => import("./Components/competition/CertificateView.js"));

// const VideoTrimmer = lazy(
//   () => import("./Components/competition/Submission/VideoTrimmer.jsx")
// );
// const Timeline = lazy(() => import("./Components/timeline/Timeline.js"));
const Admin = lazy(() => import("./Components/Admin/Admin.js"));
const Policy = lazy(() => import("./pages/PrivacyPolicy/Policy.js"));
const ForgotEmail = lazy(() => import("./Components/Forgot/ForgotEmail.jsx"));
// const Messenger = lazy(
//   () => import("./Components/OnlineChatting/Messenger.js")
// );
const PageNotFound = lazy(
  () => import("./Components/PageNotFound/PageNotFound.jsx")
);
// const FeedbackForm = lazy(
//   () => import("./Components/FeedbackForm/FeedbackForm.js")
// );
// const SimilarUser = lazy(
//   () => import("./Components/SimillarUsers/SimilarUser.js")
// );

const NewPassword = lazy(() => import("./Components/Forgot/NewPassword.jsx"));
// const NotificationPage = lazy(
//   () => import("./Components/NotificationPage/NotificationPage.js")
// );
const Users = lazy(() => import("./Components/Admin/Users/Users.js"));
// const Profile = lazy(() => import("./pages/profile/Profile.jsx"));
const SignUpForm = lazy(
  () => import("./Components/LandingPage/SignUp/SignUpForm.jsx")
);
const ForgotPassword = lazy(
  () => import("./Components/Forgot/ForgotPassword.jsx")
);
const SignUpInitial = lazy(
  () => import("./Components/LandingPage/SignUp/SignUpInitial.js")
);
// const Following = lazy(() => import("./Components/Follow/Following.jsx"));
// const Followers = lazy(() => import("./Components/Follow/Followers.jsx"));
// const SharePost = lazy(() => import("./Components/Sharepost/SharePost.js"));
// const Commentsall = lazy(() => import("./Components/Comments/Commentsall.js"));
// const Userdetails = lazy(
//   () => import("./Components/Userdetails/Userdetails.js")
// );
// const EditVideo = lazy(() => import("./Components/Edit/EditVideo.js"));
const VerifyOtp = lazy(() => import("./Components/Forgot/VerifyOtp.jsx"));
// const ReportPage = lazy(() => import("./Components/ReportPage/ReportPage.js"));
// const PostComment = lazy(() => import("./Components/Comments/PostComment.js"));
// const EditUSkills = lazy(
//   () => import("./Components/SelectSkills/EditUSkills.js")
// );
// const ProfessionalSkills = lazy(
//   () => import("./Components/SelectSkills/ProfessionalSkills.js")
// );
const About = lazy(() => import("./Components/about/About.js"));
const SimilarEmailUser = lazy(() => import("./Components/Forgot/Accounts.js"));
// const EditSkills = lazy(
//   () => import("./Components/SelectSkills/EditSkills.js")
// );
const TermsCondition = lazy(
  () => import("./Components/TermsandConditions/TermsandConditions.js")
);
// const UnprofessionalSkills = lazy(
//   () => import("./Components/SelectSkills/UnprofessionalSkills.js")
// );
const VerifyEmail = lazy(
  () => import("./Components/LandingPage/SignUp/VerifyEmail.js")
);

function App() {
  const { user, token } = useSelector((state) => state.AuthReducer);
  const [cookie, setCookie] = useCookies(["Theme"]);
  const dispatch = useDispatch();

  // This is one of the methods can use a library babel-plugin-transform-remove-console configure this in babel config
  // eslint-disable-next-line no-constant-condition
  if (ENV === "prod") {
    console.log = function no_console() { };
  }
  useEffect(() => {
    captureAttributionFromUrl();
  }, []);


  useEffect(() => {
    const updateUser = async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": `${path}`,
            Authorization: `Bearer ${token}`,
          },
        };
        const res = await axios.get(`${path}/getUserData/${user._id}`, config);
        dispatch({ type: UPDATE_ACCOUNT, payload: res.data });
      } catch (error) {
        console.error("Get user data Error: ", error);
      }
    };
    //Only run if user is logged In to fetch fresh user on startup only first time.
    if (user) {
      updateUser();
    }
  }, [])

  useEffect(() => {
    const root = window.document.documentElement;
    // console.log(cookie.Theme);
    if (user && ENV === "prod") {
      fbq('init', '1200936965148112', {
        em: user?.email || "",
        fn: user?.firstName || "",
        ln: user?.lastName || "",
        external_id: user?._id || ""
      });
      ReactGA.set({
        user_id: user?._id || "",
        user_properties: {
          email: user?.email || "",
          firstName: user?.firstName || "",
          lastName: user?.lastName || "",
        }
      })
    }

    if (user?.length !== 0) {
      if (user?.theme === "dark") {
        //commenting the dark theme out for now

        // setCookie("Theme", "dark", { path: "/" });
        // root.classList.remove("light");
        // root.classList.add("dark");

        setCookie("Theme", "light", { path: "/" });
        root.classList.remove("dark");
        root.classList.add("light");
      } else {
        setCookie("Theme", "light", { path: "/" });
        root.classList.remove("dark");
        root.classList.add("light");
      }
    } else {
      if (cookie) {
        if (cookie.Theme === "dark") {
          root.classList.remove("light");
          root.classList.add("dark");
        } else {
          root.classList.remove("dark");
          root.classList.add("light");
        }
      } else {
        setCookie("Theme", "light", { path: "/" });
        root.classList.remove("dark");
        root.classList.add("light");
      }
    }
  }, [user, cookie, setCookie]);

  const socket = useContext(WebSocketContext);

  useEffect(() => {
    if (!user) { return; }

    const sendOnline = () => {
      socket.emit("online", user._id);
    };

    const sendOffline = () => {
      socket.emit("offline", user._id);
    };

    const handleConnect = () => {
      socket.emit("join room", user._id);
    };

    const handleDisconnect = () => {
      socket.emit("leave room", user._id);
    };

    socket.emit("setup", user?._id);

    window.addEventListener("load", sendOnline);
    window.addEventListener("beforeunload", sendOffline);

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);

    return () => {
      window.removeEventListener("load", sendOnline);
      window.removeEventListener("beforeunload", sendOffline);
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
    };
  }, [socket, user]);

  useEffect(() => {
    if (user?._id) {
      socket.emit("join room", user._id);
    }
  }, [user?._id]);

  // component for redirection to play store
  const RedirectToPlayStore = () => {
    if (window.navigator.userAgent.includes("Android")) {
      const { intentUrl } = getPlaystoreLinks()
      window.location.replace(intentUrl);
      return <></>;
    } else if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) {
      console.log("ios Agent : ", window.navigator.userAgent);
      window.location.replace(
        "https://apps.apple.com/in/app/feedants/id6477408585"
      );
      return <></>;
    }
    return <Redirect exact path="/" />;
  };

  ReactGA.initialize("G-MNH124L7NM", { testMode: ENV !== "prod" });

  // useEffect(() => {
  //   //setup user for the first time
  //   socket.connect();

  //   socket.on("connect", () => {
  //     socket.emit("setup", user);
  //     socket.emit("join room", user);
  //   });

  //   socket.on("disconnect", () => {
  //     socket.emit("disconnectt", user);
  //     socket.emit("leave room", user);
  //     console.log('nope')
  //   });

  // }, [socket,user]);
  // console.log(window.location.pathname);

  return (
    // Wrapping up our complete App with the global state using Provider Tag and passing Store Variable to it From store folder
    <div className="bg-primary">
      {/* {user &&
        header &&
        location.pathname !== "/notfound" &&
        location.pathname !== "/polished" &&
        location.pathname !== "/novice" &&
        location.pathname !== "/editPSkills" &&
        location.pathname !== "/editUSkills" &&
        location.pathname !== "/about" && (
          <Header cookie={cookie} setCookie={setCookie} />
        )} */}

      <SocketNotification />
      {/* Adding Header to ever Page */}
      <Suspense fallback={<FallbackUI />}>
        <Switch>
          {/* Changed the route */}
          <Route exact path="/certificate/share" component={CertificateView} />
          <LoginRouteLink path="/" exact component={LandingPage} />
          <Route path="/about" exact component={About} />
          <Route path="/appDownload" exact component={AppDownload} />
          <Route exact path="/app" component={RedirectToPlayStore} />
          <MarketingAdminRoutes
            path="/marketingadmin"
            exact
            component={CompetitionPanel}
          />
          <MarketingAdminRoutes
            path="/submissions/:contestId"
            exact
            component={JudgingPanel}
          />
          <MarketingAdminRoutes
            path="/videoUploadTester"
            exact
            component={VideoUploadTester}
          />
          <MarketingAdminRoutes
            path="/antRewardsDashboard"
            exact
            component={ARDashboard}
          />
          <PrivateRoutes
            exact
            path={"/submissionList/:contestId/:adminAccess/:contestName"}
            component={SubmissionsList}
          />
          <PrivateRoutes
            exact
            path={"/editcontest/:contestId"}
            component={ContestEdit}
          />
          <PrivateRoutes
            exact
            path={"/judgeApplicants"}
            component={JudgeApplicantLists}
          />
          <PrivateRoutes
            exact
            path={"/advertisers"}
            component={AdvertiserPanel}
          />
          <PrivateRoutes
            exact
            path={"/advertisers/createNew"}
            component={CreateAdvertiser}
          />
          <PrivateRoutes
            exact
            path={"/advertisers/edit/:advertiserId"}
            component={CreateAdvertiser}
          />
          <PrivateRoutes
            exact
            path={"/judgeApplicants/createNew"}
            component={CreateJudgeApplication}
          />

          <AdminRoutes path="/admin" exact component={Admin} />
          <Route path="/privacy-policy" exact component={Policy} />
          <LoginRouteLink
            path="/forgotPassword"
            exact
            component={ForgotPassword}
          />
          <LoginRouteLink path="/forgotEmail" exact component={ForgotEmail} />
          <LoginRouteLink path="/newPassword" exact component={NewPassword} />
          <LoginRouteLink path="/accounts" exact component={SimilarEmailUser} />
          <RouteLinks path="/signupinitial" component={SignUpInitial} />
          <Route path="/verifyEmail" component={VerifyEmail} />
          <RouteLinks exact path="/verifyOtp" component={VerifyOtp} />
          <RouteLinks exact path="/signup" component={SignUpForm} />
          {/* <PrivateRoutes exact path="/profile" component={Profile} />
          <PrivateRoutes
            exact
            path="/accountInfo/:userId"
            component={AccountInfo}
          />
          <Route exact path="/polished" component={ProfessionalSkills} />
          <Route exact path="/mypeer" component={MyPeer} />

          <Route exact path="/novice" component={UnprofessionalSkills} />
          <Route exact path="/skillmodel" component={Skillmodel} /> */}
          <Route path="/TermsAndCondition" exact component={TermsCondition} />

          {/* After signin with google redirect user to  new page  to fill some details */}
          {/* <Route path="/googleSignIn" exact component={GoogleDetails} /> */}

          {/* <PrivateRoutes exact path="/editPost/:id" component={Edit} />
          <PrivateRoutes exact path="/editImage/:id" component={EditImage} />
          <PrivateRoutes
            exact
            path="/editVidoePost/:id"
            component={EditVideo}
          />
          <PrivateRoutes exact path="/editPSkills" component={EditSkills} />
          <PrivateRoutes exact path="/editUSkills" component={EditUSkills} />
          <PrivateRoutes exact path="/wirings" component={SimilarUser} />
          <PrivateRoutes exact path="/timeline" component={Timeline} />
          <PrivateRoutes exact path="/postComments" component={PostComment} /> */}
          {/* <PrivateRoutes exact path="/reportPost" component={ReportPage} /> */}
          {/* <PrivateRoutes exact path="/loading" component={Loading} />
          <PrivateRoutes exact path="/peerInterests" component={PeerInterest} />
          <PrivateRoutes
            exact
            path="/userDetails/:userId"
            component={Userdetails}
          />
          <PrivateRoutes path="/allcomments/:postId" component={Commentsall} />
          <PrivateRoutes path="/chatting" component={Messenger} />
          <PrivateRoutes path="/followers/:userId" component={Followers} />
          <PrivateRoutes path="/following/:userId" component={Following} />
          <PrivateRoutes
            path="/allNotifications"
            component={NotificationPage}
          />
          <PrivateRoutes path="/rewards/:contestId" component={Rewards} />
          <PrivateRoutes path="/rewardsMobile" component={RewardsMobile} />
          <PrivateRoutes path="/judges/:contestId" component={Judges} />
          <PrivateRoutes exact path="/feedback" component={FeedbackForm} />
          <Route path="/post/:postId" exact component={SharePost} /> */}
          <AdminRoutes path="/users" exact component={Users} />
          {/* <PrivateRoutes exact path="/home" component={HomePage} /> */}
          {/* <Route path="/notfound" component={ErrorPage} /> */}
          {/* <PrivateRoutes path="/competition" exact component={CompetitionNew} /> */}
          <PrivateRoutes path="/competition/:id" exact component={AllComp} />
          <Route
            path={["/competitionLink/:contestId", "/teamLink/:teamId"]}
            component={DeepLinkBanner}
          />
          <Route
            path={"/referral/:referCode"}
            component={ReferralLinkBanner}
          />
          <Route
            path={"/contest/:id"}
            component={ContestDetails}
          />
          <Route
            path={"/get-help"}
            component={GetHelp}
          />
          <Route
            path={"/leaderboard"}
            component={LeaderBoard}
          />
          <Route
            path={"/all-competition"}
            component={Competition}
          />
          <Route
            path={"/payment-status"}
            component={PaymentStatus}
          />
          <Route
            path={"/user/:id"}
            component={UserProfile}
          />
          <Route
            path={"/apply-as-judge"}
            component={ApplyAsJudge}
          />
          <Route
            path={"/shorten/:identifier/:shortCode"}
            component={UrlRedirectPage}
          />

          {/* <PrivateRoutes
            path="/submission/:contestId"
            exact
            component={Submission}
          />
          <PrivateRoutes
            path="/mystatistics/:userId"
            exact
            component={MyStatisticsDesktop}
          />
          <PrivateRoutes
            path="/statistics/:userId"
            exact
            component={MyStatistics}
          />
          <PrivateRoutes path="/videoPreview" exact component={VideoTrimmer} />  */}
          {/* <PrivateRoutes path="/levels" exact component={Levels} /> */}
          {/* <PrivateRoutes path="/mystatistics" exact component={MyStatistics} /> */}
          <Route component={PageNotFound} />
        </Switch>
      </Suspense>

      <ToastContainer></ToastContainer>
    </div>
  );
}

export default withRouter(App);
